import React, { useState } from 'react';
import PageTitle from '../components/PageTitle';
import {
  Container,
  Paper,
  Typography,
  TextField,
  Button,
  Grid,
  Box,
  Alert
} from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const LoanApplication = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    address: '',
    loanAmount: '',
    purpose: '',
    income: '',
    employment: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Format the message for WhatsApp
    const message = `New Loan Application:%0a
Name: ${formData.fullName}%0a
Email: ${formData.email}%0a
Phone: ${formData.phone}%0a
Address: ${formData.address}%0a
Loan Amount: ${formData.loanAmount}%0a
Purpose: ${formData.purpose}%0a
Monthly Income: ${formData.income}%0a
Employment: ${formData.employment}`;

    // Replace this with your actual WhatsApp business number
    const whatsappNumber = "8299866226"; // Format: country code + number
    window.open(`https://wa.me/${whatsappNumber}?text=${message}`);
  };

  return (
    <>
      <PageTitle title="Apply for Loan" />
      <Container maxWidth="md" sx={{ py: 8 }}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom align="center" color="primary">
            Loan Application
          </Typography>
          <Typography variant="subtitle1" gutterBottom align="center" sx={{ mb: 4 }}>
            Fill out the form below to apply for a loan. Your details will be sent via WhatsApp.
          </Typography>

          <form onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  fullWidth
                  label="Full Name"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  fullWidth
                  label="Email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  fullWidth
                  label="Phone Number"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  fullWidth
                  label="Loan Amount"
                  name="loanAmount"
                  type="number"
                  value={formData.loanAmount}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  label="Address"
                  name="address"
                  multiline
                  rows={2}
                  value={formData.address}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  fullWidth
                  label="Monthly Income"
                  name="income"
                  type="number"
                  value={formData.income}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  fullWidth
                  label="Employment Type"
                  name="employment"
                  value={formData.employment}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  label="Loan Purpose"
                  name="purpose"
                  multiline
                  rows={3}
                  value={formData.purpose}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12}>
                <Button
                  type="submit"
                  variant="contained"
                  size="large"
                  fullWidth
                  startIcon={<WhatsAppIcon />}
                  sx={{ mt: 2 }}
                >
                  Submit Application via WhatsApp
                </Button>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </Container>
    </>
  );
};

export default LoanApplication;